import React from "react";
import {
  chakra,
  Box,
  Container,
  Stack,
  Text,
  VisuallyHidden,
  useBreakpointValue
} from '@chakra-ui/react'
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin, FaTiktok, /* FaWhatsapp, FaTelegram, */ FaEnvelope, FaSnapchat } from 'react-icons/fa'
import { FaBluesky } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { motion } from 'framer-motion';

// Créez un wrapper motion pour le bouton social
const MotionChakraButton = motion(chakra.button);

const SocialButton = ({
  children,
  label,
  href,
  target,
  delay = 0,
}) => {
  return (
    <MotionChakraButton
      bg={'##FFD700'}
      rounded={'full'}
      w={useBreakpointValue({ base: '8', md: '8' })}
      h={useBreakpointValue({ base: '8', md: '8' })}
      cursor={'pointer'}
      as={'a'}
      href={href}
      target={target}
      rel="noopener noreferrer"
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      //transition={'background 0.3s ease'}
      _hover={{
        bg: '#ffd900cc',
      }}
      // Animation properties
      initial={{ opacity: 0, scale: 0, y: 20 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      viewport={{ once: true, margin: "10px" }}
      transition={{ 
        type: "spring", 
        stiffness: 300, 
        damping: 15, 
        delay: delay 
      }}>
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </MotionChakraButton>
  )
}

const Footer = () => {
  // Définir les délais pour l'apparition séquentielle
  const socialIcons = [
    { label: 'Facebook', icon: FaFacebook, href: 'https://facebook.com/61572904391476', target: '_blank' },
    { label: 'Instagram', icon: FaInstagram, href: 'https://www.instagram.com/cicabank?igsh=MTBkbHVweGNjN282NQ%3D%3D&utm_source=qr', target: '_blank' },
    //{ label: 'Whatsapp', icon: FaWhatsapp, href: 'https://wa.me/237693000000' },
    //{ label: 'Telegram', icon: FaTelegram, href: 'https://t.me/cicabank' },
    { label: 'X', icon: FaXTwitter, href: 'https://x.com/cicabank?s=11', target: '_blank' },
    { label: 'YouTube', icon: FaYoutube, href: 'https://youtube.com/@cicabank?si=gTXyoo6QeRPVHj6j', target: '_blank' },
    { label: 'Linkedin', icon: FaLinkedin, href: 'https://www.linkedin.com/in/cica-bank-888b8a350?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app', target: '_blank' },
    { label: 'TikTok', icon: FaTiktok, href: 'https://www.tiktok.com/@cicabank?_t=ZM-8vL134pxyvm&_r=1', target: '_blank' },
    { label: 'Snapchat', icon: FaSnapchat, href: 'https://snapchat.com/t/QVbWUsjU', target: '_blank' },
    { label: 'Bluesky', icon: FaBluesky, href: 'https://bsky.app/profile/cicabank.bsky.social', target: '_blank' },
    { label: 'Email', icon: FaEnvelope, href: 'mailto:info@cicabank.com', target: '_blank' },
  ];

  // Move useBreakpointValue hooks to the top level of the component
  const fontSize = useBreakpointValue({ base: 'md', md: '2md' });
  const stackSpacing = useBreakpointValue({ base: '0', md: '4' });
  const iconSize = useBreakpointValue({ base: 20, md: 25 });

  return (
    <Box
      bgColor={'#F9F9F9'}
      color={'black'}>
      <Container
        as={Stack}
        maxW={'6xl'}
        py={4}
        //direction={{ base: 'column', md: 'row' }}
        direction={'column'}
        fontSize={fontSize}
        spacing={4}
        justify={{ base: 'center', md: 'space-between' }}
        align={{ base: 'center', md: 'center' }}>
        <Text>© 2025 Cicabank. All rights reserved</Text>
        <Stack direction={'row'} spacing={stackSpacing}>
          {socialIcons.map((social, index) => (
            <SocialButton 
              key={social.label}
              label={social.label} 
              href={social.href}
              target={social.target}
              delay={index * 0.1} // Délai progressif pour chaque icône
            >
              <social.icon size={iconSize}/>
            </SocialButton>
          ))}
        </Stack>
      </Container>
    </Box>
  )
}

export default Footer;
